import { Button, List, Typography } from 'antd';
import { FC, ReactNode } from 'react';
import { BoxArrowUpRight } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { PageUsageForTag, PageUsageForType, useGetByIdPageNodeQuery } from '@/modules/Pages';

interface Props {
  siteId: string;
  loading: boolean;
  pageNodePages: BaseQueryParams<typeof useGetByIdPageNodeQuery>['data']['pages'];
}

export const CollapsePagesList: FC<Props> = ({
  loading,
  pageNodePages,
  siteId
}) => {
  return (
    <List
      dataSource={ pageNodePages }
      loading={ loading }
      renderItem={ (page): ReactNode => (
        <List.Item
          key={ page.id }
          extra={ [
            <Link
              key="goToPage"
              target="_blank"
              to={ AppRoutes.PagesById.replace(':siteId', siteId).replace(':pageId', page.id) }
            >
              <Button type="link" size="small" icon={ <BoxArrowUpRight/> }/>
            </Link>
          ] }
          actions={ [
            Object.entries(page.usageFor).map(([key, value]) => (
              <PageUsageForTag key={ `usageFor:${ key }` } value={{ [key]: value } as PageUsageForType}/>
            ))

          ] }
        >
          <Typography.Title level={ 5 } style={{ margin: 0, maxWidth: '40%', width: '100%' }} ellipsis={{ suffix: page.title.slice(-12).trim() }}>
            { page.title.slice(0, -12).trim() }
          </Typography.Title>
        </List.Item>
      ) }
    />
  );
};
